import React from 'react';
import { motion } from 'framer-motion';
import { ChromeButton } from './ChromeButton';
export function FinalCTA() {
  return <section className="w-full bg-white py-20 sm:py-24" data-id="element-38">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5
      }} className="relative overflow-hidden rounded-3xl bg-[#1d9bf0] px-6 py-14 text-center sm:px-12" data-id="element-40">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_0%,rgba(255,255,255,0.18),transparent_55%)]" data-id="element-41" />
          <div className="relative" data-id="element-42">
            <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-43">
              Screenshot X posts the clean way
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-lg text-white/90" data-id="element-44">
              Free, local-only, and privacy-first. Add X2PIC to Chrome and
              capture your first post in seconds.
            </p>
            <div className="mt-8 flex justify-center" data-id="element-45">
              <ChromeButton variant="light" data-id="element-46" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}